import { render, staticRenderFns } from "./HomeworkList.vue?vue&type=template&id=678dd830&scoped=true&"
import script from "./HomeworkList.vue?vue&type=script&lang=js&"
export * from "./HomeworkList.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkList.vue?vue&type=style&index=0&id=678dd830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678dd830",
  null
  
)

export default component.exports